// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"51950900","391":"5922518d","451":"80ae1ebb","471":"294ff93e","531":"4f1b0cfe","623":"bc5ee9dd","695":"a9f0b41f","775":"f4ef09ab","995":"d77f37ba"}[chunkId] + ".chunk.js";
};